import TIM from 'tim-js-sdk'
import COSSDK from 'cos-js-sdk-v5'

// 根据域名判断使用的应用SDKAPPID
let domain = window.location.host
let SDKAPPID = 1400802255

if (domain == 'csccopenuat.fangchengbao.com' || domain == 'localhost:8080') {
  SDKAPPID = 1400795831
}

// 初始化 SDK 实例
const tim = TIM.create({
  SDKAppID: SDKAPPID,
})

window.setLogLevel = tim.setLogLevel

// 无日志级别
tim.setLogLevel(1)

// 注册 cos
tim.registerPlugin({ 'cos-js-sdk': COSSDK })
export default tim
